import React, { useState } from "react";
import Contact from "./components/contact/Contact";
import Experience from "./components/experience/Experience";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Intro from "./components/intro/Intro";
import Portfolio from "./components/portfolio/Portfolio";

// import Testimonials from './components/testimonials/Testimonials';
import Topbar from "./components/topbar/Topbar";
// import MeBuyCoffee from "./components/mebuyCoffee/MeBuyCoffee";

const App = () => {
    const [activeNav, setActiveNav] = useState("#home");
    return (
        <>
            <Header setActiveNav={setActiveNav} />
            <Topbar setActiveNav={setActiveNav} activeNav={activeNav} />
            <Intro setActiveNav={setActiveNav} />
            <Experience />
            <Portfolio />
            {/* <Testimonials /> */}
            <Contact />
            {/* <MeBuyCoffee /> */}
            <Footer setActiveNav={setActiveNav} />
        </>
    );
};

export default App;
